const VERSION = "9.2.2";
export {
  VERSION
};
